@if (!sessionExpired) {
  <div class="w-full">
    <gdx-header
      [visible]="loggedIn && roleList.length > 0 && isAppLoad"
    ></gdx-header>
    @if (accessGranted) {
      <div>
        <router-outlet
          (activate)="onActivate($event)"
          class="w-screen justify-between"
          [ngClass]="!footerVisible ? '' : 'p-9'"
        ></router-outlet>
      </div>
    }
    @if (accessDenied) {
      <div>
        <router-outlet></router-outlet>
      </div>
    }
    @if (loggedIn && roleList.length > 0 && isAppLoad) {
      <div>
        @if (footerVisible) {
          <gdx-footer></gdx-footer>
        }
      </div>
    }
  </div>
  @if (isNoRoleModal) {
    <div>
      <gdx-no-role-tag [showModal]="isNoRoleModal"></gdx-no-role-tag>
    </div>
  }
  @if (!isAppLoad) {
    <div>
      <gdx-no-app
        [showModal]="!isAppLoad"
        [selectedRole]="selectedRole"
      ></gdx-no-app>
    </div>
  }
}
@if (sessionExpired) {
  <div>
    <div
      class="fixed z-999 w-1/2 overflow-hidden bg-white border-solid border-4 border-blue-300 top-1/3 left-1/4 text-zinc-700 p-8"
      >
      <h3 class="font-bold text-4xl mb-4">{{ reload_message.WARN_MESSAGE }}</h3>
      <p class="text-xl">{{ reload_message.MAIN_MESSAGE }}</p>
    </div>
  </div>
}
<app-loader></app-loader>
